module.exports = __webpack_public_path__ + "img/upload.5d5f4418.svg";